export const ClipboardTickIcon = () => (
    <svg
        width='25'
        height='25'
        viewBox='0 0 25 25'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M9.81006 15.2L11.3101 16.7L15.3101 12.7'
            stroke='#0088B2'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M10.5 6.5H14.5C16.5 6.5 16.5 5.5 16.5 4.5C16.5 2.5 15.5 2.5 14.5 2.5H10.5C9.5 2.5 8.5 2.5 8.5 4.5C8.5 6.5 9.5 6.5 10.5 6.5Z'
            stroke='#0088B2'
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M16.5 4.52002C19.83 4.70002 21.5 5.93002 21.5 10.5V16.5C21.5 20.5 20.5 22.5 15.5 22.5H9.5C4.5 22.5 3.5 20.5 3.5 16.5V10.5C3.5 5.94002 5.17 4.70002 8.5 4.52002'
            stroke='#0088B2'
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
